import React, { Component } from 'react';
import ReactD3 from "react-d3-components";
import { connect } from "react-redux";
import './airGraph.css';
import TimeSeriesSparkLineScatterPlot from './TimeSeriesSparkLineScatterPlot'

class AirGraph extends Component {
  constructor(props){
    super(props);
    this.state = {};
  }

  componentDidMount(){
    this.updateDimensions = _ => {
      let rect = this.widget && this.widget.getBoundingClientRect();
      if(!rect)
        return

      this.setState({width: rect.width-155, height:rect.height-80})
    }

    setTimeout(_ => this.updateDimensions(), 500);
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  render() {
    let {width, height} = this.state;
    let validData = this.props.data && this.props.data.length > 2;
    let validDimensions = width && height;
    let valid = validData && validDimensions;

    return (
      <div id='airGraph' className='widget' ref={element => {
        this.widget = element;
      }}>
        <div style={{display: 'flex', alignItems: "center", justifyContent: "center", flexGrow: "1"}}>
          {valid ?
            <TimeSeriesSparkLineScatterPlot
              data={this.props.data}
              height={height}
              width={width*0.75}
              margin={20}
              selectX={datum => datum.time}
              selectY={datum => datum.value}
            />
          :
          <div>No data available</div>}
        </div>

        <div style={{display: "flex", flexDirection: "column", justifyContent: "space-evenly", width: "220px"}}>

          <div style={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
            <svg height="2" width="30" style={{alignItems: 'center'}}>
              <line x1="0" y1="0" x2="30" y2="0" style={{strokeWidth: 4}} />
            </svg>
            <div style={{marginLeft: 10, fontSize: 14}}>Our indoor Air quality</div>
          </div>
          <div style={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
            <svg height="2" width="30">
              <line x1="0" y1="0" x2="30" y2="0" style={{stroke: 'rgba(80, 80, 80, 0.7)', strokeWidth: 3, strokeDasharray: "5,5"}} />
            </svg>
            <div style={{marginLeft: 10, fontSize: 14}}>Average Baden-Baden</div>
          </div>
          <div className='forest' style={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
            <div className='graphIcon mdi mdi-tree' />
            <div style={{marginLeft: 10, fontSize: 14}}>Black forest Air quality </div>
          </div>
          <div className='office' style={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
            <div className='graphIcon mdi mdi-office-building' />
            <div style={{marginLeft: 10, fontSize: 14}}>Average indoor Air quality</div>
          </div>

        </div>
      </div>
    )
  }
}

export default connect(state => {
  let data = null;

  if(state.general.company.customerId &&
    state.firestore.data.customers &&
    state.firestore.data.customers[state.general.company.customerId] &&
    state.firestore.data.customers[state.general.company.customerId].airQualityData){

    let dataAsObject = state.firestore.data.customers[state.general.company.customerId].airQualityData;

    data = Object.keys(dataAsObject)
      .map(key => dataAsObject[key])
      .filter(o => o.time && o.value)
      .map(o => ({...o, time: new Date(Date.parse(o.time))}))
      .sort((a, b) => a.time - b.time);

    data = data.slice(Math.max(data.length - 288, 0));
  }

  return {
    data
  }
}, null)(AirGraph);
